
<div class="row row-body">
    <div class="col-md-2">{{ size }}</div>
    <div class="col-md-4">&#8364; 19,95</div>
    <div class="col-md-2"><span style="color:#4bc103">50+</span></div>
    <div class="col-md-4">
        
        <!-- dummy quantity picker -->
        <div class="input-group input-group-right-aligned">
            <div class="input-group-prepend">
                <button class="quantity-update quantity-minus" tabindex="-1"><i class="fa fa-minus"></i></button>
            </div>
            <input class="form-control" min="1" type="number">
            <div class="input-group-append">
                <button class="quantity-update quantity-plus" tabindex="-1"><i class="fa fa-plus"></i></button>
            </div>
            <button class="btn btn-success" tabindex="-1"><i class="fa fa-cart-arrow-down"></i></button>
        </div>  
           
    </div>
</div>